import { DisplayField, StepperContext } from '@digitools/honest-ui';
import React, { useContext } from 'react';
import styled from 'styled-components';
import AddRequest from './AddRequest';
import ReviewConditionsCircumstance from './ReviewConditionsCircumstance';
import useTranslate from 'src/hooks/useTranslate';
import useAsDataContext from '../../hooks/useAsDataContext';
import { ReviewAccommodationDetailsText } from '../../constants/ReviewAccommodationDetailsText';
import { ReviewText } from '../../constants/ReviewText';
const RequestList = styled('ol') `
  margin: 0 0 var(--spacing-xl-2);
  padding: 0;
  list-style: none;
`;
const AccommodationDetails = ({ displayButton, }) => {
    const { t } = useTranslate();
    const stepper = useContext(StepperContext);
    const { accommodationRequestDataArray } = useAsDataContext();
    const requestsTitle = t(ReviewAccommodationDetailsText.AccommodationRequestsheading);
    const handleEditBtnClick = () => {
        stepper.edit(2);
        window.scrollTo(0, 0);
    };
    const onEdit = displayButton ? handleEditBtnClick : undefined;
    return (<div data-testid='review-accommodation-details'>
      <ReviewConditionsCircumstance onEdit={onEdit}/>
      {/* Header only: the requests below need numbered, accent-bordered blocks DisplayField can't render */}
      <DisplayField title={requestsTitle} headingLevel='h3' className='hui-mb-md' fields={[]} onEdit={onEdit} 
    // Passed explicitly: the app wraps honest-react's LanguageProvider, not honest-ui's, so the default would stay English
    editLabel={t(ReviewText.editButton)}/>
      <RequestList aria-label={requestsTitle}>
        {accommodationRequestDataArray?.map(data => (<AddRequest key={data.id} count={data.id} accommodationData={data}/>))}
      </RequestList>
    </div>);
};
export default React.memo(AccommodationDetails);
